// Shared hook — loads classes from Firestore once on mount
import { useState, useEffect, useRef } from "react";
import { useData } from "../contexts/DataContext";

export function useClasses() {
  const { getClasses } = useData();
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(true);
  const getClassesRef = useRef(getClasses);

  // Keep ref current without triggering re-runs
  useEffect(() => { getClassesRef.current = getClasses; });

  useEffect(() => {
    let cancelled = false;
    getClassesRef.current()
      .then(data => { if (!cancelled) setClasses(data); })
      .catch(() => { if (!cancelled) setClasses([]); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []); // mount only — intentional

  return { classes, loading };
}
